export default __webpack_public_path__ + "static/media/01__o_preview_2.332eb1c3.jpg";